import { Colors, H1, H4, Input, Shadows, VerticalGroup } from "@saysom/shared"
import { useRouter } from "next/router"
import React, { useState } from "react"
import Body from "../components/body/body"
import { InnerContainer } from "../components/body/body_style"
import { Form, Label, SmallContainer } from "../styles"

export enum ContactType {
	Job,
	Press,
	BookBasic,
	BookPremium,
	BookEnterprise,
	Else,
}

const contactStrings = [
	"Job",
	"Press",
	"Book Basic Space",
	"Book Premium Space",
	"Book Enterprise Space",
	"Else",
]

const descriptionStrings = [
	"Want to be part of the SaySom team and bring people together in the digital space? Write us a message!",
	"You want to do an interview with one of our founders, need pictures or other press material? Write us a message!",
	"Just a small step to your personal SaySom Space. Tell us briefly which package you have chosen and what exactly you need. One of our employees will get back to you soon!",
	"Just a small step to your personal SaySom Space. Tell us briefly which package you have chosen and what exactly you need. One of our employees will get back to you soon!",
	"Just a small step to your personal SaySom Space. Tell us briefly which package you have chosen and what exactly you need. One of our employees will get back to you soon!",
	"Have a question? Just want to chat? Don't hesitate, just contact us!",
]

const headerStrings = [
	"Job Request",
	"Press Request",
	"Booking Request",
	"Booking Request",
	"Booking Request",
	"Contact",
]

const Newsletter = () => {
	const [name, setName] = useState("")
	const [email, setEmail] = useState("")

	const router = useRouter()

	const submit = (e) => {
		e.preventDefault()

		const nameParts = name.split(" ")

		fetch(
			"https://api.hsforms.com/submissions/v3/integration/submit/8923531/da848f34-4aec-493a-9fa1-2541dc517bac",
			{
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
					submittedAt: new Date().getTime(),
					fields: [
						{
							name: "email",
							value: email,
						},
						{
							name: "firstname",
							value: nameParts[0],
						},
						{
							name: "lastname",
							value: nameParts.length > 1 ? nameParts[1] : "",
						},
						{ name: "newsletter_active", value: "Ja" },
						{ name: "contact_type", value: "host" },
					],
				}),
			}
		)
			.then((r) => r.json())
			.then((v) => {
				if (v.status !== undefined) {
					alert("Error: Data not valid. Please check your input")
				} else {
					alert("Thank you!")

					router.push("/")
				}
			})
	}

	return (
		<Body
			className="bg-flowy-up dark:bg-flowy-up-dark"
			whiteFooter
			noPadding
			subtitle="Contact"
		>
			<InnerContainer
				style={{ justifyContent: "center", alignItems: "center" }}
			>
				<H1
					style={{
						flex: "0",
						backgroundImage: Colors.flowyText,
						WebkitBackgroundClip: "text",
						WebkitTextFillColor: "transparent",
						whiteSpace: "nowrap",
						alignSelf: "center",
						textAlign: "center",
					}}
				>
					Newsletter
				</H1>
				<VerticalGroup style={{ maxWidth: "500px", marginTop: "23px" }}>
					<H4
						style={{
							marginBottom: "24px",
							alignSelf: "center",
							textAlign: "center",
						}}
					>
						Signup to get the latest information about SaySom!
					</H4>
					<SmallContainer
						style={{ flex: 0 }}
						backgroundColor="white"
						shadow={Shadows.highlighted}
					>
						<Form onSubmit={submit}>
							<Label style={{ marginBottom: "20px" }}>
								Name
								<Input
									placeholder="Name"
									type="text"
									value={name}
									onChange={(value) => setName(value)}
								/>
							</Label>
							<Label style={{ marginBottom: "20px" }}>
								Email
								<Input
									placeholder="Email"
									type="email"
									value={email}
									onChange={(value) => setEmail(value)}
								/>
							</Label>

							<button
								disabled={
									name.length === 0 ||
									email.length === 0 ||
									!email.includes("@")
								}
								type="submit"
								className=" flex self-center  bg-black text-white mt-4 shadow-md rounded-md px-5 py-2 text-sm font-semibold select-none cursor-pointer hover:bg-action transition-colors"
							>
								Subscribe to newsletter
							</button>
						</Form>
					</SmallContainer>
				</VerticalGroup>
			</InnerContainer>
		</Body>
	)
}

export default Newsletter
